<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">

  <div class="row">

    <div class="col-sm-4 mb-4">
      <app-treeview-systems
            parent_icon="folder"
            child_icon="videocam"
            parent_table_name="ngaccessmanagement_ngfoldertree"
            parent_table_pk="id"
            parent_table_ref_value="item_name"
            child_table_name="ngaccessmanagement_ngsystemprofile"
            child_table_displayname="system_name"
            child_table_fk="folder_id_id"
            algorithm="m2mtable"
            title="Location"
            sort_by = "folder"
            (messageSelectedMultipleNodesWithTheirText)="recieve_selected_multiple_items($event)"
          ></app-treeview-systems>
    </div>

    <div class="col-sm-8 mb-4" >
      <div class="mb-1">
        <button mat-raised-button  color="primary"  type="submit" id="addBtn"
                    [disabled]="this.received_selected_items?.length==0 || disableFetchButton"
                    (click)="sendDataToReportGenerator()">
            <mat-icon aria-hidden="false" aria-label="Add" >summarize</mat-icon>
            <span style="margin: 0px;padding: 0px;" >Fetch Data</span>
          </button>
      </div>


      <div style="max-height: 75vh; ">
        <h3 class="col-sm-12 text-center" style="background-color: black; color: white; padding: 10px;">Please select data headers to be fetched</h3>
        <section class="example-section">
          <span class="example-list-section">
            <mat-checkbox class="example-margin"
                          [checked]="allComplete"
                          [color]="systemHeader.color"
                          [indeterminate]="someComplete()"
                          (change)="setAll($event.checked)">
              <span style="color: blue;font-weight: bold;">{{systemHeader.name}}</span>
            </mat-checkbox>
          </span>
          <div class="example-list-section">
            <ul>
              <li *ngFor="let subtask of systemHeader.subtasks">
                <mat-checkbox [(ngModel)]="subtask.completed"
                              [color]="subtask.color"
                              (ngModelChange)="updateAllComplete()">
                  {{subtask.shownValue}}
                </mat-checkbox>
              </li>
            </ul>
          </div>
        </section>
      </div>


      <div >

        <!-- <div style=" margin: auto; width: 50%;"> -->
          <!-- <button (click)="exportexcel()">Export to Excel</button> -->

          <!-- <table id="excel-table">
            <tr>
              <th>Id</th>
            </tr>
            <tr *ngFor="let item of systemsData">
              <td>{{item.system_ip}}</td>
            </tr>
          </table> -->

        <!-- </div> -->

      </div>


    </div>


  </div>
</div>


